import { atom } from "recoil";

export const scenariosState = atom({
  key: "compareScenarios.scenariosState",
  default: [],
});